import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, Transition as _Transition, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-50faf9ae")

_pushScopeId("data-v-50faf9ae")
const _hoisted_1 = {
  class: "layout-menu-container",
  id: "kn-main-menu",
  ref: "mainMenu"
}
const _hoisted_2 = { class: "menu-scroll-content" }
const _hoisted_3 = {
  class: "profile",
  ref: "menuProfile"
}
const _hoisted_4 = {
  key: 0,
  class: "profile-name"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("i", { class: "pi pi-fw pi-chevron-down" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("span", { class: "profile-role" }, "Marketing", -1)
const _hoisted_7 = {
  class: "layout-menu profile-menu",
  ref: "menuProfileSlide"
}
const _hoisted_8 = { class: "layout-menu" }
const _hoisted_9 = /*#__PURE__*/_createVNode("span", { class: ['p-menuitem-icon', 'fas fa-cog'] }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_InfoDialog = _resolveComponent("InfoDialog")
  const _component_LanguageDialog = _resolveComponent("LanguageDialog")
  const _component_RoleDialog = _resolveComponent("RoleDialog")
  const _component_DownloadsDialog = _resolveComponent("DownloadsDialog")
  const _component_NewsDialog = _resolveComponent("NewsDialog")
  const _component_LicenseDialog = _resolveComponent("LicenseDialog")
  const _component_MainMenuAdmin = _resolveComponent("MainMenuAdmin")
  const _component_MainMenuTieredMenu = _resolveComponent("MainMenuTieredMenu")
  const _component_q_menu = _resolveComponent("q-menu")
  const _component_MainMenuItem = _resolveComponent("MainMenuItem")
  const _component_ScrollPanel = _resolveComponent("ScrollPanel")
  const _directive_tooltip = _resolveDirective("tooltip")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_InfoDialog, {
      visibility: _ctx.display,
      "onUpdate:visibility": _cache[1] || (_cache[1] = ($event: any) => (_ctx.display = $event))
    }, null, 8, ["visibility"]),
    _createVNode(_component_LanguageDialog, {
      visibility: _ctx.languageDisplay,
      "onUpdate:visibility": _cache[2] || (_cache[2] = ($event: any) => (_ctx.languageDisplay = $event))
    }, null, 8, ["visibility"]),
    _createVNode(_component_RoleDialog, {
      visibility: _ctx.roleDisplay,
      "onUpdate:visibility": _cache[3] || (_cache[3] = ($event: any) => (_ctx.roleDisplay = $event)),
      mandatory: _ctx.mandatoryRole()
    }, null, 8, ["visibility", "mandatory"]),
    _createVNode(_component_DownloadsDialog, {
      visibility: _ctx.downloadsDisplay,
      "onUpdate:visibility": _cache[4] || (_cache[4] = ($event: any) => (_ctx.downloadsDisplay = $event))
    }, null, 8, ["visibility"]),
    _createVNode(_component_NewsDialog, {
      visibility: _ctx.newsDisplay,
      "onUpdate:visibility": _cache[5] || (_cache[5] = ($event: any) => (_ctx.newsDisplay = $event))
    }, null, 8, ["visibility"]),
    (_ctx.user && _ctx.user.isSuperadmin && _ctx.isEnterprise)
      ? (_openBlock(), _createBlock(_component_LicenseDialog, {
          key: 0,
          visibility: _ctx.licenseDisplay,
          "onUpdate:visibility": _cache[6] || (_cache[6] = ($event: any) => (_ctx.licenseDisplay = $event))
        }, null, 8, ["visibility"]))
      : _createCommentVNode("", true),
    (_ctx.technicalUserFunctionalities && _ctx.technicalUserFunctionalities.length > 0)
      ? (_openBlock(), _createBlock(_component_MainMenuAdmin, {
          key: 1,
          openedPanelEvent: _ctx.adminMenuOpened,
          model: _ctx.technicalUserFunctionalities,
          onClick: _ctx.itemClick
        }, null, 8, ["openedPanelEvent", "model", "onClick"]))
      : _createCommentVNode("", true),
    _createVNode(_component_q_menu, {
      ref: "menu",
      target: _ctx.menuTargetElem,
      anchor: "top right",
      self: "top left"
    }, {
      default: _withId(() => [
        _createVNode(_component_MainMenuTieredMenu, {
          items: _ctx.selectedCustomMenu,
          onLink: _ctx.itemClick
        }, null, 8, ["items", "onLink"])
      ]),
      _: 1
    }, 8, ["target"]),
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _withDirectives(_createVNode("button", {
          class: "p-link",
          onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.toggleProfile && _ctx.toggleProfile(...args)))
        }, [
          _createVNode("img", {
            alt: "Profile",
            class: "profile-image",
            src: _ctx.getProfileImage(_ctx.user)
          }, null, 8, ["src"]),
          (_ctx.user)
            ? (_openBlock(), _createBlock("span", _hoisted_4, _toDisplayString(_ctx.user.fullName), 1))
            : _createCommentVNode("", true),
          _hoisted_5,
          _hoisted_6
        ], 512), [
          [_directive_tooltip, _ctx.user && _ctx.user.fullName]
        ])
      ], 512),
      _createVNode(_Transition, { name: "slide-down" }, {
        default: _withId(() => [
          _withDirectives(_createVNode("ul", _hoisted_7, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.commonUserFunctionalities, (item, i) => {
              return (_openBlock(), _createBlock(_Fragment, { key: i }, [
                item
                  ? (_openBlock(), _createBlock(_component_MainMenuItem, {
                      key: 0,
                      item: item,
                      onClick: _ctx.itemClick
                    }, null, 8, ["item", "onClick"]))
                  : _createCommentVNode("", true)
              ], 64))
            }), 128))
          ], 512), [
            [_vShow, _ctx.showProfileMenu]
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_ScrollPanel, {
        style: { height: _ctx.menuDimensions }
      }, {
        default: _withId(() => [
          _createVNode("ul", _hoisted_8, [
            (_ctx.technicalUserFunctionalities && _ctx.technicalUserFunctionalities.length > 0)
              ? (_openBlock(), _createBlock("li", {
                  key: 0,
                  role: "menu",
                  onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.toggleAdminMenu && _ctx.toggleAdminMenu(...args)))
                }, [
                  _hoisted_9
                ]))
              : _createCommentVNode("", true),
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.allowedUserFunctionalities, (item, i) => {
              return (_openBlock(), _createBlock(_component_MainMenuItem, {
                key: i,
                item: item,
                onClick: _ctx.itemClick,
                badge: _ctx.getBadgeValue(item),
                onMouseover: ($event: any) => (_ctx.toggleMenu($event, item))
              }, null, 8, ["item", "onClick", "badge", "onMouseover"]))
            }), 128)),
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dynamicUserFunctionalities, (item, i) => {
              return (_openBlock(), _createBlock(_component_MainMenuItem, {
                key: i,
                item: item,
                onClick: _ctx.itemClick,
                onMouseover: ($event: any) => (_ctx.toggleMenu($event, item)),
                internationalize: true
              }, null, 8, ["item", "onClick", "onMouseover"]))
            }), 128))
          ])
        ]),
        _: 1
      }, 8, ["style"])
    ])
  ], 512))
})